<template>
  <div id="app" :class="[$mq, {TA:isTestAchat}]" ref="app">
    <vue-headful :title="$t('appTitle')" :description="$t('appDescription')" :image="$t('appImage')" :url="$t('appUrl')" />
    <div class="banana-background" v-if="$mq === 'desktop'"></div>
    <Header class="header" />
    <Navigation v-if="!unavailable" />
    <Cookies v-if="!cookies" @close="hasCookie"/>
    <div class="content">
      <router-view  v-if="!unavailable" />
      <Unavailable v-else-if="unavailable"></Unavailable>
    </div>
    <div class="push"></div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navigation from "@/components/Navigation.vue";
import Cookies from "@/components/Cookies.vue";
import Footer from "@/components/Footer.vue";
import vueHeadful from "vue-headful";
import Unavailable from './views/Unavailable.vue';
import { mapGetters } from "vuex";

export default {
  name: "App",
  data() {
    return {
      cookies: false,
      steps: ["Energies", "Consommations"]
    };
  },
  computed: {
    ...mapGetters("common", ["isTestAchat"]),
    currentRoute() {
      return this.$router.currentRoute.name;
    },
    unavailable() {
      return process.env.BLOCK_CHECK;
    }
  },
  methods: {
    hasCookie() {
      if (process.env.NODE_ENV !== 'production'){
        this.cookies = true;
        return;
      }
        this.cookies = this.$cookies.isKey('megacookie');

    },
    setTheme() {
      if(this.isTestAchat) {
        this.$store.dispatch("theme/setThemeTA");
        this.$refs.app.style.fontFamily = "Lato";
        document.body.style.background = 'unset';
        document.body.style.backgroundColor = '#E6EEF0';

      } else {
        this.$store.dispatch("theme/setThemeMega");
      }
    }
  },
  created() {
    if (!this.$store.state.contact.civilities.length) {
      this.$store.dispatch("contact/getCivilities", this.$i18n.locale);
    }

    if(this.isTestAchat) {
      this.$store.dispatch("theme/setThemeTA");
    } else {
      this.$store.dispatch("theme/setThemeMega");
    }

    this.hasCookie();

  },
  mounted() {
    this.setTheme();
  },
  components: {
    Header,
    Navigation,
    Unavailable,
    Cookies,
    Footer,
    vueHeadful
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Regular.otf");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Medium.otf");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Bold.otf");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: Lato;
  src: url("./assets/fonts/Lato-Bold.ttf");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: Lato;
  src: url("./assets/fonts/Lato-Regular.ttf");
  font-weight: 500;
  font-style: normal;
}

html,
body {
  // height: 100%;
  background: url("./assets/header_check_repeat.jpg") repeat;
  margin: 0;

  &.modal-open {
    max-height: calc(100vh - 210px);
    overflow-y: hidden;
  }
}

#app {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #231f20;
  display: flex;
  flex-direction: column;
  min-height: 100vh;


  &.desktop {
    // background: url("./assets/header_check_repeat.jpg") repeat 0 -800px;
    // background:  $yellow;

    .banana-background {
      z-index: 0;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: url("./assets/bg_banana_white.svg") center bottom/3200px no-repeat, url("./assets/header_check_repeat.jpg") repeat 0 -800px;
    }
  }

  &.cookies {
    overflow: hidden;
  }

  .header {
    z-index: 1;
    background: $white;
  }

  .content {
    // background: white;
    flex: 1 0 auto;
    z-index: 1;
  }

  .push {
   height: 100%;
   flex: 1 0 auto;
  }

  .title {
    margin: 20px;
    margin-bottom: 0;

    &.desktop {
      margin: 20px auto;
      margin-bottom: 0;
      width: 700px;
    }

    h1 {
      display: block;
      text-align: left;
      font-size: 1.7rem;
      margin: 0;
      margin-bottom: 10px;
    }

    h2 {
      display: block;
      text-align: left;
      font-weight: normal;
      font-size: 1rem;
      margin: 0;
    }
  }

  &.TA {
    .banana-background {
      background: unset;
      background-color: #E6EEF0!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue